import React from 'react'
import moment from 'moment'
import { COLORES, obtenerColorStock } from '../../../../config/colores'
import TableValueAction from '../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../Camiones/containers/busquedaCpa/InfoCpa'
import DetalleMercaderiaFumigada from '../../containers/listados/DetalleMercaderiaFumigada'
import DetalleMercaderiaSecada from '../../containers/listados/DetalleMercaderiaSecada'
import DetalleMercaderiaSecadaDosMas from '../../containers/listados/DetalleMercaderiaSecadaDosMas'
import DetalleDescargaPorGrado from '../../containers/listados/DetalleDescargaPorGrado'
import DetalleDescargaGrado3 from '../../containers/listados/DetalleDescargaGrado3'
import DetalleFueraDeGrado from '../../containers/listados/DetalleFueraDeGrado'
import DetalleZarandeo from '../../containers/listados/DetalleZarandeo'
import DetalleMercaderia from '../../components/listados/DetalleMercaderia'
import DetalleAlmacenajeEspecial from '../../containers/listados/DetalleAlmacenajeEspecial'
import DetalleMovimientosDiariosExportador from '../../components/listados/DetalleMovimientosDiariosExportador'
import OperacionesTransferenciasExportador from '../../containers/listados/movimientosExportador/OperacionesTransferenciasExportador'
import DetalleConsultaPorCosecha from '../../containers/controlExistencias/DetalleConsultaPorCosecha'
import EstimacionCuposAsignados from '../../components/estimacionStock/EstimacionCuposAsignados'
import EstimacionCargaBuque from '../../components/estimacionStock/EstimacionCargaBuque'
import EstimacionCumplimiento from '../../components/estimacionStock/EstimacionCumplimiento'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import EstimacionEspacioDisponible from '../../components/estimacionStock/EstimacionEspacioDisponible'
import ProyectadosPool from '../../components/estimacionStock/ProyectadosPool'
import { obtenerDiaDeLaSemana } from '../../../../config/dias_semana'
import EstimacionUnidadValor from '../../components/estimacionStock/EstimacionUnidadValor'
import OperacionesProyecciones from '../../components/estimacionStock/OperacionesProyecciones'

//* * Columnas correspondientes a listados de facturacion */
export const COL_MERCADERIA_FUMIGADA = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Cantidad de camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['nombreCereal']
        const exportador = detalle['razonSocialExportador']
        const titulo = `Detalle de mercarderia fumigada - ${cereal} - ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleMercaderiaFumigada detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'netoTotalCamiones',
    label: 'Neto total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  }
]

export const FUMIGADA_TO_PRINT = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '170'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '100'
  },
  {
    name: 'cantidadCamiones',
    label: 'Camiones',
    width: '70'
  },
  {
    name: 'netoTotalCamiones',
    label: 'Neto Kgs.',
    width: '100'
  }
]

export const COL_DETALLE_MERCADERIA_FUMIGADA = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true,
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'razonSocialCargador',
    label: 'Titular de cupo',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} Kg.</>
      }
    }
  }
]

export const DETALLE_FUMIGADA_TO_PRINT = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '80'
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    width: '150'
  },
  {
    name: 'fechaDeDescarga',
    label: 'Descarga',
    width: '60'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '70'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '50'
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: '50'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '80'
  }
]

export const COL_MERCADERIA_SECADA = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['nombreCereal']
        const exportador = detalle['razonSocialExportador']
        const titulo = `Detalle de mercarderia secada - ${cereal} - ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleMercaderiaSecada detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'netoTotalCamiones',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return <>{rebaja} kg.</>
      }
    }
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  }
]

export const COL_DETALLE_MERCADERIA_SECADA = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'razonSocialCargador',
    label: 'Titular de cupo',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return <>{rebaja} kg.</>
      }
    }
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }
  }
]

export const COL_MERCADERIA_SECADA_2_MAS = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['cereal']
        const exportador = detalle['razonSocialExportador']
        const titulo = `Detalle de mercarderia secada +2% - ${cereal} - ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleMercaderiaSecadaDosMas detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return <>{rebaja} kg.</>
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return <>{rebaja} kg.</>
      }
    }
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'quincena',
    label: 'Quincena',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true
    }
  }
]

export const COL_DETALLE_SECADA_2_MAS = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return <>{rebaja} kg.</>
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return <>{rebaja} kg.</>
      }
    }
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'quincena',
    label: 'Quincena',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true
    }
  }
]

export const SECADA_TO_PRINT = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '130'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'cantidadCamiones',
    label: 'Camiones',
    width: '50'
  },
  {
    name: 'netoTotalCamiones',
    label: 'Peso neto descarga',
    width: '70'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja total',
    width: '70'
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    width: '70'
  }
]

export const DETALLE_SECADA_TO_PRINT = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '70'
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    width: '130'
  },
  {
    name: 'fechaDeDescarga',
    label: 'Descarga',
    width: '60'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '60'
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: '50'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    width: '70'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '60'
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    width: '70'
  }
]

export const SECADA_MAS_2_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: '70'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '130'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'cantidadCamiones',
    label: 'Camiones',
    width: '50'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    width: '70'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja total',
    width: '70'
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    width: '70'
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    width: '70'
  },
  {
    name: 'quincena',
    label: 'Quincena',
    width: '70'
  }
]

export const DETALLE_SECADA_2_MAS_TO_PRINT = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '80'
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    width: '180'
  },
  {
    name: 'fechaDeDescarga',
    label: 'Descarga',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '60'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    width: '70'
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    width: '70'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '70'
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Peso neto stock',
    width: '70'
  }
]

export const COL_DESCARGA_POR_GRADO = [
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['cereal']
        const variedad = ((detalle['cerealVariedad']).trim() !== 'UNDEF') ? `${detalle['cerealVariedad']} - ` : ''
        const exportador = detalle['exportador']
        const titulo = `Detalle descarga por grado - ${cereal} - ${variedad} ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleDescargaPorGrado detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoStockGrado1',
    label: 'Peso neto stock grado 1',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <div
          style={{
            color: COLORES.grey.dark,
            fontSize: '1rem',
            width: '100%',
            fontWeight: 'bold'
          }}
        >
          {neto} kg.
        </div>
          : ' - '
      }
    }
  },
  {
    name: 'pesoStockGrado2',
    label: 'Peso neto stock grado 2',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <div
          style={{
            color: COLORES.grey.dark,
            fontSize: '1rem',
            width: '100%',
            fontWeight: 'bold'
          }}
        >
          {neto} kg.
        </div>
          : ' - '
      }
    }
  },
  {
    name: 'pesoStockGrado3',
    label: 'Peso neto stock grado 3',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <div
          style={{
            color: COLORES.grey.dark,
            fontSize: '1rem',
            width: '100%',
            fontWeight: 'bold'
          }}
        >
          {neto} kg.
        </div>
          : ' - '
      }
    }
  },
  {
    name: 'pesoStockTotal',
    label: 'Total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (
          <div
            style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
          >
            {neto} kg.
          </div>
        )
      }
    }
  }
]

export const DESCARGA_POR_GRADO_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: '180'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'cantidadCamiones',
    label: 'Camiones',
    width: '50'
  },
  {
    name: 'pesoStockGrado1',
    label: 'Peso stock grado 1',
    width: '100'
  },
  {
    name: 'pesoStockGrado2',
    label: 'Peso stock grado 2',
    width: '100'
  },
  {
    name: 'pesoStockGrado3',
    label: 'Peso stock grado 3',
    width: '100'
  },
  {
    name: 'pesoStockTotal',
    label: 'Peso stock total',
    width: '100'
  }
]

export const COL_DETALLE_DESCARGA_POR_GRADO = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cargador',
    label: 'Cargador',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'pesoStockGrado1',
    label: 'Peso stock grado 1',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoStockGrado2',
    label: 'Peso stock grado 2',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoStockGrado3',
    label: 'Peso stock grado 3',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  }
]

export const DETALLE_POR_GRADO_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: '70'
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '90'
  },
  {
    name: 'cargador',
    label: 'Cargador',
    width: '180'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'pesoStockGrado1',
    label: 'Peso stock grado 1',
    width: '100'
  },
  {
    name: 'pesoStockGrado2',
    label: 'Peso stock grado 2',
    width: '100'
  },
  {
    name: 'pesoStockGrado3',
    label: 'Peso stock grado 3',
    width: '100'
  }
]

export const COL_MERCADERIA_GRADO_3 = [
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['cereal']
        const variedad = ((detalle['cerealVariedad']).trim() !== 'UNDEF') ? `${detalle['cerealVariedad']} - ` : ''
        const exportador = detalle['exportador']
        const titulo = `Detalle descarga de grado 3- ${cereal} - ${variedad} ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleDescargaGrado3 detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0
          ? <div
            style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
          >
            {neto} kg.
          </div>
          : ' - '
      }
    }
  }
]

export const MERCADERIA_GRADO_3_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '80'
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: '200'
  },
  {
    name: 'cantidadCamiones',
    label: 'Camiones',
    width: '50'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '100'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '100'
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock',
    width: '100'
  }
]

export const COL_DETALLE_GRADO_3 = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cargador',
    label: 'Cargador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: true,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    options: {
      filter: true,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock ',
    options: {
      filter: true,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  }
]

export const COL_DETALLE_GRADO_3_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: '70'
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '90'
  },
  {
    name: 'cargador',
    label: 'Cargador',
    width: '180'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    width: '100'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '100'
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso stock',
    width: '100'
  }
]

export const COL_MERCADERIA_FUERA_GRADO = [
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['cereal']
        const variedad = ((detalle['cerealVariedad']).trim() !== 'UNDEF') ? `${detalle['cerealVariedad']} - ` : ''
        const exportador = detalle['exportador']
        const titulo = `Detalle descarga fuera de estandar - ${cereal} - ${variedad} ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleFueraDeGrado detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaAdicionalKg',
    label: 'Rebaja adicional',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <div
          style={{
            color: COLORES.grey.dark,
            fontSize: '1rem',
            width: '100%',
            fontWeight: 'bold'
          }}
        >
          {neto} kg.
        </div>
          : ' - '
      }
    }
  }
]

export const MERCADERIA_FUERA_GRADO_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '80'
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: '200'
  },
  {
    name: 'cantidadCamiones',
    label: 'Camiones',
    width: '50'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '80'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '80'
  },
  {
    name: 'rebajaAdicionalCamara',
    label: 'Rebaja adicional',
    width: '80'
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock',
    width: '80'
  }
]

export const COL_DETALLE_FUERA_DE_GRADO = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cargador',
    label: 'Cargador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaAdicionalCamara',
    label: 'Rebaja adicional %',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja } %</> : ' - '
      }
    }
  },
  {
    name: 'rebajaAdicionalKg',
    label: 'Rebaja adicional',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock ',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  }
]

export const DETALLE_FUERA_DE_GRADO_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: '70'
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '90'
  },
  {
    name: 'cargador',
    label: 'Cargador',
    width: '150'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '70'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    width: '70'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '70'
  },
  {
    name: 'rebajaAdicionalCamara',
    label: 'Rebaja adicional %',
    width: '70'
  },
  {
    name: 'rebajaAdicionalKg',
    label: 'Rebaja adicional',
    width: '70'
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso stock',
    width: '70'
  }
]

export const COL_MERCADERIA_REBAJA_ADICIONAL = [
  {
    name: 'razonSocialExp',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'razonSocialCar',
    label: 'Cargador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'gradoLiqCamara',
    label: 'Grado a liquidar',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true
    }
  },
  {
    name: 'rebajaAdicionalCamara',
    label: 'Rebaja adicional %',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja } %</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return rebaja > 0 ? <>{rebaja} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso neto stock ',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  }
]

export const MERCADERIA_REBAJA_ADICIONAL_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: '60'
  },
  {
    name: 'razonSocialExp',
    label: 'Exportador',
    width: '120'
  },
  {
    name: 'razonSocialCar',
    label: 'Cargador',
    width: '120'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '60'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '60'
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '70'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto descarga',
    width: '65'
  },
  {
    name: 'rebajaKg',
    label: 'Rebaja',
    width: '50'
  },
  {
    name: 'rebajaAdicionalCamara',
    label: 'Rebaja adicional %',
    width: '50'
  },
  {
    name: 'gradoLiqCamara',
    label: 'Grado a liquidar',
    width: '60'
  },
  {
    name: 'pesoNetoStockNivel1',
    label: 'Peso stock',
    width: '70'
  }
]

export const COL_TOTAL_ALMACENAJE = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'almacenaje',
    label: 'Almacenaje',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (alm) => {
        return <><b>{alm}</b> kg.</>
      }
    }
  },
  {
    name: 'detalle',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: (detalle) => {
        const total = detalle['almacenaje']
        const titulo = `Detalle movimientos diarios`
        return ((total !== 0) &&
          <DetalleMercaderia
            titulo={titulo}
            contenido={
              <DetalleMovimientosDiariosExportador
                detalle={detalle}
              />
            }
          />
        )
      }
    }

  }
]

export const TOTAL_ALMACENAJE_TO_PRINT = [
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '200'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '80'
  },
  {
    name: 'almacenaje',
    label: 'Almacenaje',
    width: '150'
  }
]

export const COL_DETALLE_MOV_EXP = [
  {
    name: 'razonSocial',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'stock',
    label: 'Stock',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (stock) => {
        return <><b>{stock}</b> kg.</>
      }
    }
  },
  {
    name: 'acumulado',
    label: 'Almacenaje',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (acumulado) => {
        return <><b>{acumulado}</b> kg.</>
      }
    }
  }
]

export const DETALLE_MOV_EXP_TO_PRINT = [
  {
    name: 'razonSocial',
    label: 'Exportador',
    width: '180'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '80'
  },
  {
    name: 'stock',
    label: 'Stock',
    width: '90'
  },
  {
    name: 'acumulado',
    label: 'Almacenaje',
    width: '90'
  }
]

export function getColumnasAlmacenajeEspecial (fechaD, fechaH, fechaConsulta) {
  return ([
    {
      name: 'razonSocial',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect'
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'stock',
      label: 'Stock',
      options: {
        filter: false,
        sort: true,
        total: true,
        customBodyRender: (alm) => {
          const color = (alm < 0) ? '#5d5d5d' : 'inherit'
          return <b style={{ color: color }}>{alm !== 0 && alm} {alm === 0 && ' - '} { alm !== 0 && 'kg.'}</b>
        }
      }
    },
    {
      name: 'detalle',
      label: ' ',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: (detalle) => {
          const cereal = detalle['cereal']
          const exportador = detalle['exportador']
          const razonSocial = detalle['razonSocial']
          const total = detalle['stock']
          const titulo = `Detalle almacenaje especial ${fechaConsulta}`
          return ((total !== 0) &&
            <DetalleMercaderia
              titulo={titulo}
              contenido={
                <DetalleAlmacenajeEspecial
                  fechaD={fechaD}
                  fechaH={fechaH}
                  exportador={exportador}
                  cereal={cereal}
                  total={total}
                  razonSocial={razonSocial}
                />
              }
            />
          )
        }
      }

    }
  ])
}

export const ALMACENAJE_ESPECIAL_TO_PRINT = [
  {
    name: 'razonSocial',
    label: 'Exportador',
    width: '250'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '140'
  },
  {
    name: 'cantidadCamiones',
    label: 'Cantidad de camiones',
    width: '80'
  },
  {
    name: 'almacenaje',
    label: 'Almacenaje',
    width: '150'
  }
]

export const COL_DETALLE_ALMACENAJE_ESPECIAL = [
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'stock',
    label: 'Stock',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (stock) => {
        return <b>{stock} kg.</b>
      }
    }
  },
  {
    name: 'capUtilizada',
    label: 'Cap. utilizada',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'stockAlmacenaje',
    label: 'Stock almacenaje',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (alm) => {
        return <b>{alm} kg.</b>
      }
    }
  },
  {
    name: 'acumuladoStockAlmacenaje',
    label: 'Acumulado',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (acumulado) => {
        return <b>{acumulado} kg.</b>
      }
    }
  }
]

export const DETALLE_ALMACENAJE_ESP_TO_PRINT = [
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '80'
  },
  {
    name: 'stock',
    label: 'Stock',
    width: '100'
  },
  {
    name: 'capUtilizada',
    label: 'Cap. utilizada',
    width: '100'
  },
  {
    name: 'stockAlmacenaje',
    label: 'Stock almacenaje',
    width: '100'
  },
  {
    name: 'acumuladoStockAlmacenaje',
    label: 'Acumulado',
    width: '100'
  }
]

export const COL_MOVIMIENTOS_EXPORTADOR = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'razonSocial',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cargaEntrante',
    label: 'Carga entrante',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (value) => {
        return <>{value} kg.</>
      }
    }
  },
  {
    name: 'cargaSaliente',
    label: 'Carga saliente',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (value) => {
        return <>{value} kg.</>
      }
    }
  },
  {
    name: 'movimientosInternos',
    label: 'Movimientos internos',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (value) => {
        return <>{value} kg.</>
      }
    }
  },
  {}
]

export const MOVIMIENTOS_EXPORTADOR_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '80'
  },
  {
    name: 'razonSocial',
    label: 'Exportador',
    width: '220'
  },
  {
    name: 'cargaEntrante',
    label: 'Carga entrante (kg.)',
    width: '130'
  },
  {
    name: 'cargaSaliente',
    label: 'Carga saliente(kg.)',
    width: '130'
  },
  {
    name: 'movimientosInternos',
    label: 'Movimientos internos (kg.)',
    width: '130'
  }
]

export const COL_DETALLE_MOVIMIENTO_EXP = []

export const DETALLE_MOVI_EXP_TO_PRINT = []

export const COL_TRANSFERENCIAS_EXP = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'razonSocialOrigen',
    label: 'Exportador origen',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'razonSocialDestino',
    label: 'Exportador destino',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (value) => {
        return <>{value} kg.</>
      }
    }
  },
  {
    name: 'detalle',
    label: ' ',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (detalle) => {
        return <OperacionesTransferenciasExportador detalle={detalle} />
      }
    }
  }
]

export const TRANSFERENCIAS_EXP_TO_PRINT = [
  {
    name: 'fecha',
    label: 'Fecha',
    width: '80'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '80'
  },
  {
    name: 'razonSocialOrigen',
    label: 'Exportador origen',
    width: '240'
  },
  {
    name: 'razonSocialDestino',
    label: 'Exportador destino',
    width: '240'
  },
  {
    name: 'cantidad',
    label: 'Cantidad (kg.)',
    width: '100'
  }
]

export const COL_TOTAL_ZARANDEO = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'detalle',
    label: 'Cantidad de camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['cereal']
        const exportador = detalle['razonSocialExportador']
        const fecha = detalle['fechaDeDescarga']
        const titulo = `Detalle de mercarderia zarandeada el ${moment(fecha).format('DD-MM-YYYY')} - ${cereal} - ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleZarandeo fecha={fecha} exportador={exportador} cereal={cereal} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (value) => {
        return <><b>{value}</b> kg.</>
      }
    }
  }
]

export const TOTAL_ZARANDEO_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '220'
  },
  {
    name: 'cantidadCamiones',
    label: 'Cantidad de camiones',
    width: '100'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '100'
  }
]

export const COL_DETALLE_ZARANDEO = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'nombre',
    label: 'Motivo de zarandeo',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  }
]

export const DETALLE_ZARANDEO_TO_PRINT = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '100'
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    width: '200'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '100'
  },
  {
    name: 'nombre',
    label: 'Motivo de zarandeo',
    width: '150'
  }
]

export const COL_INDICES = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'netoTotalCtg',
    label: 'Neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'netoG1',
    label: 'Neto G1',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'netoG2',
    label: 'Neto G2',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'netoG3',
    label: 'Neto G3',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKgG3',
    label: 'Rebaja G3',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'indiceMermaG3',
    label: 'Indice G3',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} %</> : ' - '
      }
    }
  },
  {
    name: 'rebajaKgFe',
    label: 'Rebaja FE',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} kg.</> : ' - '
      }
    }
  },
  {
    name: 'indiceMermaFe',
    label: 'Indice FE',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return neto > 0 ? <>{neto} %</> : ' - '
      }
    }
  }
]

export const INDICES_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'netoTotalCtg',
    label: 'Neto total',
    width: '80'
  },
  {
    name: 'netoG1',
    label: 'Neto G1',
    width: '80'
  },
  {
    name: 'netoG2',
    label: 'Neto G2',
    width: '80'
  },
  {
    name: 'netoG3',
    label: 'Neto G3',
    width: '80'
  },
  {
    name: 'rebajaKgG3',
    label: 'Rebaja G3',
    width: '80'
  },
  {
    name: 'indiceMermaG3',
    label: 'Indice G3',
    width: '80'
  },
  {
    name: 'rebajaKgFe',
    label: 'Rebaja FE',
    width: '80'
  },
  {
    name: 'indiceMermaFe',
    label: 'Indice FE',
    width: '80'
  }
]

//* Control de existencias */

export const COL_EXISTENCIA_DIARIA = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'stockExportadores',
    label: 'Stock neto exportadores',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (stock) => {
        return <>{stock} kg.</>
      }
    }
  },
  {
    name: 'stockTerminal',
    label: 'Stock neto terminal',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (stock) => {
        return <>{stock} kg.</>
      }
    }
  },
  {
    name: 'mercaderiaInterdicta',
    label: 'Interdictos',
    options: {
      filter: true,
      sort: true,
      total: true,
      customBodyRender: (stock) => {
        return <>{stock} kg.</>
      }
    }
  },
  {
    name: 'total',
    label: 'Existencia neta',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (total) => {
        return <>{total} kg.</>
      }
    }
  },
  {
    name: 'totalBruto',
    label: 'Existencia bruta',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (total) => {
        return <>{total} kg.</>
      }
    }
  }
]

export const COL_EXISTENCIA_DIARIA_VARIEDAD = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'stockExportadores',
    label: 'Stock neto exportadores',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (stock) => {
        return <>{stock} kg.</>
      }
    }
  },
  {
    name: 'stockTerminal',
    label: 'Stock neto terminal',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (stock) => {
        return <>{stock} kg.</>
      }
    }
  },
  {
    name: 'mercaderiaInterdicta',
    label: 'Interdictos',
    options: {
      filter: true,
      sort: true,
      total: true,
      customBodyRender: (stock) => {
        return <>{stock} kg.</>
      }
    }
  },
  {
    name: 'total',
    label: 'Existencia neta',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (total) => {
        return <>{total} kg.</>
      }
    }
  },
  {
    name: 'totalBruto',
    label: 'Existencia bruta',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (total) => {
        return <>{total} kg.</>
      }
    }
  }
]

export function columnasEstimacionSemanal (
  cereal,
  netoPromedioTn,
  isSimulacion,
  isSimulacionExportador,
  showEspacioDisponible = false,
  unidadVisual = 'TN',
  unidadVisualDescarga = 'CAMIONES',
  actualizarFecha = () => {},
  toggleUnidadHandler = () => {}
) {
  let columns = []
  columns = [
    {
      name: 'fechaGrupal',
      label: 'Fecha',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: false,
        viewColumns: false,
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            color: 'white',
            background: '#333333',
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            color: 'white',
            background: '#333333',
            zIndex: 101
          }
        }),
        customBodyRender: (f) => {
          const diaDeLaSemana = obtenerDiaDeLaSemana(f)
          const dia = diaDeLaSemana ? diaDeLaSemana.substring(0, 3) : ''
          let colorStyle = 'inherit'

          if (dia === 'Dom') {
            colorStyle = '#e58787'
          }

          return f && <span onClick={() => actualizarFecha(f)} className='fecha-proyeccion' style={{ color: colorStyle }}>{f} ({dia})</span>
        }
      }
    }
  ]

  const background = COLORES.grey.dark

  columns.push({
    name: `${cereal}_entry`,
    label: 'POOL ',
    options: {
      filter: false,
      viewColumns: false,
      sort: false,
      display: isSimulacion && isSimulacionExportador,
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (d) => {
        return {
          style: {
            color: COLORES.grey.dark,
            textAlign: 'center',
            backgroundColor: d ? COLORES.grey.light : COLORES.grey.dark,
            borderLeft: 'none'
            // border: selected ? '1x solid'  : 'inherit'
          }
        }
      },
      customBodyRender: (entry) => {
        const fecha = entry.fechaGrupal
        return isSimulacionExportador && fecha && <ProyectadosPool fecha={fecha} cereal={cereal} />
      }
    }
  })

  columns.push({
    name: `${cereal}_entry`,
    label: 'Faltante',
    options: {
      filter: false,
      viewColumns: false,
      sort: false,
      display: isSimulacion,
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (d) => {
        return {
          style: {
            color: COLORES.grey.dark,
            textAlign: 'center',
            backgroundColor: d.props.style ? d.props.style.backgroundColor : COLORES.grey.light,
            borderLeft: 'none'
          }
        }
      },
      customBodyRender: (entry) => {
        const embarqueProyectado = entry.embarquePotencial && entry.embarquePotencial > 0
        const stockFinal = entry.stockFinal
        const cumplimiento = entry.cumplimiento
        const netoConCumplimiento = netoPromedioTn * cumplimiento / 100

        const sugerencia = (embarqueProyectado && stockFinal < 0 && isSimulacion)
          ? <div style={{ color: '#b5130aa8', backgroundColor: COLORES.grey.light }}>
            <>
              {Math.round(stockFinal / netoConCumplimiento)}
              <LocalShippingIcon style={{ margin: '0 5px' }} />
            </>
          </div>
          : (isNaN(stockFinal)) ? <div style={{ backgroundColor: COLORES.grey.dark }} /> : <></>
        return sugerencia
      }
    }
  })

  columns.push({
    name: `${cereal}_entry`,
    label: 'Cupos a descargar',
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customHeadRender: (columnMeta) => {
        const detalleHead = isSimulacion ? 'Cantidad cupos | Simular' : 'Cupos asignados habilitados + proyectados'
        return (
          <th
            key={columnMeta.index}
            style={{
              backgroundColor: background,
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              borderColor: background,
              position: 'sticky',
              top: 0,
              zIndex: 10
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              Cupos a descargar

              <span style={{ fontSize: '0.7rem', fontWeight: 'normal', marginTop: '2px' }}>
                {detalleHead}
              </span>
            </div>
          </th>
        )
      },
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (entry) => {
        return {
          style: {
            color: entry.props.cupos === 'CONFIG' ? 'white' : 'inherit',
            textAlign: 'center',
            borderLeft: `1px solid ${background}`,
            backgroundColor: entry.props.cupos === 'CONFIG' ? COLORES.grey.dark : 'inherit'
          }
        }
      },
      customBodyRender: (entry) => {
        const c = entry.cuposADescargar || 0
        const proyectados = entry.cuposProyectados || 0
        const fecha = entry && entry.fechaGrupal
        const cumplimiento = entry.cumplimiento
        const descargaPotencial = entry.descargaPotencial
        return <EstimacionCuposAsignados
          cupos={c}
          proyectados={proyectados}
          cereal={cereal}
          fecha={fecha}
          cumplimiento={cumplimiento}
          descargaPotencial={descargaPotencial}
        />
      }
    }
  })

  columns.push({
    name: `${cereal}_entry`,
    label: 'Cumplimiento',
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      // display: cereal !== 'TODOS',
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (entry) => {
        const cumplimiento = entry && entry.props.cumplimientoCupo
        return {
          style: {
            color: COLORES.grey.dark,
            textAlign: 'center',
            borderLeft: cumplimiento !== 'CONFIG' && `1px solid ${background}`,
            backgroundColor: cumplimiento === 'CONFIG' ? COLORES.grey.dark : 'inherit'
          }
        }
      },
      customBodyRender: (entry) => {
        let c = entry.cumplimiento
        const fecha = entry.fechaGrupal
        const proyectados = entry.cuposProyectados
        const cuposADescargar = entry.cuposADescargar
        const descargaPotencial = entry.descargaPotencial
        const cuposTotal = cuposADescargar + proyectados

        if (cereal === 'TODOS') {
          const descargaEnCamiones = descargaPotencial / netoPromedioTn
          if (cuposADescargar > 0) {
            c = Math.round((descargaEnCamiones / cuposTotal) * 100)
          }
        }

        return <EstimacionCumplimiento
          cumplimientoCupo={c}
          cuposProyectados={proyectados}
          cereal={cereal}
          fecha={fecha}
        />
      }

    }
  })

  columns.push({
    name: `${cereal}_descargaPotencial`,
    label: 'Descarga potencial',
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customHeadRender: (columnMeta) => {
        return (
          <th
            key={columnMeta.index}
            style={{
              backgroundColor: background,
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              borderColor: background,
              cursor: 'pointer',
              position: 'sticky',
              top: 0,
              zIndex: 10
            }}
            onClick={() => toggleUnidadHandler('descarga')}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              Descarga potencial

              <span style={{ fontSize: '0.7rem', fontWeight: 'normal', marginTop: '2px' }}>
                ({unidadVisualDescarga === 'TN' ? 'Toneladas' : 'Camiones'})
              </span>
            </div>
          </th>
        )
      },
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (d) => {
        return {
          style: {
            color: COLORES.grey.dark,
            textAlign: 'center',
            backgroundColor: !d && COLORES.grey.dark
          }
        }
      },
      customBodyRender: (d) => {
        const descargaEnCamiones = Math.round(d / netoPromedioTn)
        return (d >= 0) &&
        <div style={{ display: 'flex', alignItems: 'center' }} className='animation-zoomInUp' >
          { d > 0 &&
          <>
            <span
              style={{
                fontSize: '1rem',
                color: COLORES.green.medium,
                fontWeight: 'bold',
                margin: '0 2px'
              }}
            >
                    +
            </span>

            <EstimacionUnidadValor
              toneladas={d}
              camiones={descargaEnCamiones}
              unidad={unidadVisualDescarga}
            />

          </>
          }
        </div>
      }
    }
  })

  columns.push({
    name: `${cereal}_stockFinal`,
    label: `${cereal}`,
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => {
        return (
          <th
            key={columnMeta.index}
            style={{
              backgroundColor: background,
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              borderColor: background,
              cursor: 'pointer',
              position: 'sticky',
              top: 0,
              zIndex: 10
            }}
            onClick={() => { toggleUnidadHandler('stock') }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {cereal}

              <span style={{ fontSize: '0.7rem', fontWeight: 'normal', marginTop: '2px' }}>
                ({unidadVisual === 'TN' ? 'Toneladas' : 'Camiones'})
              </span>
            </div>
          </th>
        )
      },
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: 'white',
          textAlign: 'center',
          fontWeight: 'bold',
          borderColor: background
        }
      }),
      setCellProps: (stock) => {
        const valorStock = stock && stock.props.toneladas ? parseInt(stock.props.toneladas) : parseInt(stock)
        const colorStock = !isNaN(valorStock) ? obtenerColorStock(valorStock) : { color: 'transparent' }

        return {
          style: {
            color: colorStock.color || COLORES.grey.dark,
            textAlign: 'center',
            minWidth: '100px',
            backgroundColor: !isNaN(valorStock) ? colorStock.backgroundColor : COLORES.grey.dark
          }
        }
      },
      customBodyRender: (stock) => {
        const stockCamiones = Math.round(stock / netoPromedioTn)

        return stock && <EstimacionUnidadValor
          toneladas={stock}
          camiones={stockCamiones}
          unidad={unidadVisual}
        />
      }
    }
  })

  columns.push({
    name: `${cereal}_entry`,
    label: 'Embarque',
    options: {
      filter: false,
      viewColumns: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (embarque) => {
        const fechaDeCarga = embarque.props.fechaDeCarga
        return {
          style: {
            color: COLORES.grey.dark,
            textAlign: 'center',
            borderRight: !!fechaDeCarga && `1px solid ${background}`,
            backgroundColor: fechaDeCarga ? 'inherit' : COLORES.grey.dark
          }
        }
      },
      customBodyRender: (entry) => {
        const carga = (entry && entry.embarquePotencial) || 0
        const fecha = entry && entry.fechaGrupal
        return entry ? <EstimacionCargaBuque carga={carga} fechaDeCarga={fecha} cereal={cereal} /> : null
      }
    }
  })

  columns.push({
    name: 'espacioAcumuladoTotal',
    label: 'Espacio disponible',
    options: {
      filter: false,
      viewColumns: false,
      sort: false,
      display: showEspacioDisponible,
      setCellHeaderProps: () => ({
        style: {
          backgroundColor: background,
          color: '#bdbdbd',
          textAlign: 'center',
          fontWeight: '200',
          fontSize: '0.9rem',
          borderColor: background
        }
      }),
      setCellProps: (d) => {
        const espacio = (d && d.props && d.props.espacioAcumulado) || null
        return {
          style: {
            color: COLORES.grey.dark,
            textAlign: 'center',
            padding: 0,
            backgroundColor: !espacio || isNaN(espacio) ? COLORES.grey.dark : 'inherit'
          }
        }
      },
      customBodyRender: (espacioAcumulado) => {
        return espacioAcumulado ? <EstimacionEspacioDisponible espacioAcumulado={espacioAcumulado} /> : ''
      }
    }
  })

  return columns
}

export const COL_PROYECCION = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      filterType: 'multiselect',
      sort: true
    }
  },
  {
    name: 'cantidadAsignada',
    label: 'Cupos proyectados',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cumplimiento',
    label: 'Cumplimiento',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (cumplimiento) => {
        return <>{cumplimiento} %</>
      }
    }
  },
  {
    name: 'proyeccion',
    label: ' ',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (proyeccion) => {
        return <OperacionesProyecciones proyeccion={proyeccion} />
      }
    }
  }

]

export const COL_COSECHA = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad && variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'cosecha',
    label: 'Cosecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'brutoStock',
    label: 'Peso bruto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'netoStock',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'detalle',
    label: 'Cantidad de camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidadCamiones']
        const cereal = detalle['cereal']
        const cosecha = detalle['cosecha']
        const titulo = `Detalle descargas - ${cereal} - Cosecha: ${cosecha}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleConsultaPorCosecha detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  }
]

export const COSECHA_TO_PRINT = []

export const COL_DETALLE_COSECHA = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad && variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'cosecha',
    label: 'Cosecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'brutoStock',
    label: 'Peso bruto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'netoStock',
    label: 'Peso neto stock',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const DETALLE_COSECHA_TO_PRINT = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '80'
  },
  {
    name: 'Cosecha',
    label: 'Cosecha',
    width: '80'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'brutoStock',
    label: 'Peso bruto stock',
    width: '80'
  },
  {
    name: 'netoStock',
    label: 'Peso neto stock',
    width: '80'
  }
]

export const COL_RECONOCIMIENTO = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad && variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'cantidadMermaHumedad',
    label: 'Cantidad merma humedad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'cantidadMermaVolatil',
    label: 'Cantidad merma volatil',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }
  },
  {
    name: 'cantidadMermaVolatil',
    label: 'Cantidad merma volatil',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }
  },
  {
    name: 'cantidadSobrante',
    label: 'Cantidad sobrante',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }
  },
  {
    name: 'cantidadTotal',
    label: 'Cantidad total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }

  }
]

export const RECONOCIMIENTO_TO_PRINT = [
  {
    name: 'fecha',
    label: 'Fecha',
    width: '80'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '90'
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '90'
  },
  {
    name: 'cantidadMermaHumedad',
    label: 'Cantidad merma humedad',
    width: '130'
  },
  {
    name: 'cantidadMermaVolatil',
    label: 'Cantidad merma volatil',
    width: '130'
  },
  {
    name: 'cantidadSobrante',
    label: 'Cantidad sobrante',
    width: '130'
  },
  {
    name: 'cantidadTotal',
    label: 'Cantidad total',
    width: '130'
  }
]

export const COL_STOCK_PRESUNTO = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => {
        return moment(fecha).format('DD-MM-YYYY')
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad && variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'stockPotencial',
    label: 'Stock potencial',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'stockPotencialHumedad',
    label: 'Stock potencial humedad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'stockPotencialVolatil',
    label: 'Stock potencial volatil',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return <>{peso} kg.</>
      }
    }
  }
]

export const STOCK_PRESUNTO_TO_PRINT = [
  {
    name: 'fecha',
    label: 'Fecha',
    width: '80'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '90'
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: '90'
  },
  {
    name: 'cantidadMermaHumedad',
    label: 'Cantidad merma humedad',
    width: '130'
  },
  {
    name: 'cantidadMermaVolatil',
    label: 'Cantidad merma volatil',
    width: '130'
  },
  {
    name: 'cantidadSobrante',
    label: 'Cantidad sobrante',
    width: '130'
  },
  {
    name: 'cantidadTotal',
    label: 'Cantidad total',
    width: '130'
  }
]

export const ESTIMACION_SEMANAL_TO_PRINT = [
  {
    name: 'fecha',
    label: 'Fecha',
    width: '110'
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: '110'
  },
  {
    name: 'stockInicial',
    label: 'Stock inicial',
    width: '110'
  },
  {
    name: 'cuposAsignados',
    label: 'Cupos asignados',
    width: '110'
  },
  {
    name: 'descargaPotencial',
    label: 'Descarga potencial',
    width: '110'
  },
  {
    name: 'embarquePotencial',
    label: 'Embarque potencial',
    width: '110'
  },
  {
    name: 'stockFinal',
    label: 'Stock final',
    width: '110'
  }
]

export const COL_ESTIMACION_POR_CEREAL = [

]

export const ESTIMACION_POR_CEREAL_TO_PRINT = [

]
